import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { VerificationFileState } from '@store/slices/docs-verification/docs-verification-slice';
import { docsVerificationSlice } from '@store/slices/docs-verification/docs-verification-slice';
import { scrollTop } from '@utils/util';

import { DocumentsStepEnum } from '../types';

type UseNextClickProps = {
    onSubmit: () => Promise<void>;
    documentsStep: DocumentsStepEnum;
};

export const useNextClick = ({ onSubmit, documentsStep }: UseNextClickProps) => {
    const dispatch = useDispatch();

    const nextClick = useCallback(
        async (documentsFiles: VerificationFileState[]) => {
            const successDocuments = documentsFiles.filter((item) => item.status.success).length;
            const isTwoSideDocument = documentsFiles.find((item) => item.isTwoSideDocument);
            const isCountryFoundInFiles = documentsFiles.find((item) => item.country);

            if (isTwoSideDocument) {
                if (successDocuments === 1) {
                    dispatch(
                        docsVerificationSlice.actions.setDocumentsStep(
                            DocumentsStepEnum.UPLOAD_SECOND_SIDE,
                        ),
                    );
                    dispatch(docsVerificationSlice.actions.setIsCameraMode(true));

                    return;
                }

                if (successDocuments === 2) {
                    if (
                        !isCountryFoundInFiles &&
                        documentsStep !== DocumentsStepEnum.SELECT_COUNTRY
                    ) {
                        dispatch(
                            docsVerificationSlice.actions.setDocumentsStep(
                                DocumentsStepEnum.SELECT_COUNTRY,
                            ),
                        );

                        return;
                    }
                    await onSubmit();
                    scrollTop();
                }
            }

            if (successDocuments === 1) {
                if (!isCountryFoundInFiles && documentsStep !== DocumentsStepEnum.SELECT_COUNTRY) {
                    dispatch(
                        docsVerificationSlice.actions.setDocumentsStep(
                            DocumentsStepEnum.SELECT_COUNTRY,
                        ),
                    );
                    scrollTop();

                    return;
                }
                await onSubmit();
                scrollTop();
            } else {
                if (successDocuments === 2) {
                    return;
                }
                dispatch(docsVerificationSlice.actions.setIsCameraMode(true));
            }
        },
        [dispatch, documentsStep, onSubmit],
    );

    return { nextClick };
};
